import _axios from '@/plugins/axios'
import store from '@/store'
export const getBaiduASRToken = () => {
  return new Promise((resolve, reject) => {
    _axios({
      // url: "https://openapi.baidu.com/oauth/2.0/token",
      url: '/baidu-asr-token-api/token',
      method: 'get',
      params: {
        client_id: '6nGvRHNeeIkREMQG3DXAhz7f',
        client_secret: 'uZymeF6PpriifLszznKvcrXn8WMhcfNs',
        grant_type: 'client_credentials'
      }
    })
      .then((res) => {
        if (!res?.access_token) {
          return reject(res)
        }
        return resolve(res)
      })
      .catch((error) => {
        return reject(error)
      })
  })
}

export const baiduASRApi = (token, data, needTest) => {
  console.log('enter baiduASRApi needTest', needTest)
  if (!(token && data)) {
    return Promise.reject('缺少必备参数')
  }
  let params = {
    dev_pid: '1537',// 1537
    // lm_id: '21423',// 多加的 自训练平台模型id
    cuid: '123456PHP',
    token: token
  }
  if (needTest){
    params = {
      dev_pid: '80001',// 1537
      lm_id: '21423',// 多加的 自训练平台模型id
      cuid: '123456PHP',
      token: token
    }
  }
  return new Promise((resolve, reject) => {
    _axios({
      url: '/baidu-asr-api/pro_api',// server_api
      method: 'post',
      params: params,
      headers: {
        'Content-Type': 'audio/pcm;rate=16000'
      },
      timeout: 1000 * 30,
      data: data
    })
      .then((res) => {
        if (res?.err_no != 0) {
          return reject(res)
        }
        return resolve(res)
      })
      .catch((error) => {
        return reject(error)
      })
  })
}
